import React from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { checkIsUrl } from '@ballerine/common';
import { TextWithNAFallback } from '@/components/atoms/TextWithNAFallback';
import { BallerineLink } from '@/components/atoms/BallerineLink';

const columnHelper = createColumnHelper<{
  domain: string;
  relatedNodeType: string;
  relatedNode: string;
}>();

export const columns = [
  columnHelper.display({
    id: 'index',
    header: 'Number',
    cell: info => {
      const index = info.cell.row.index + 1;

      return (
        <div className="w-16 max-w-16 min-w-16">
          <TextWithNAFallback className={`ps-8 truncate`}>{index}</TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('domain', {
    header: 'Domain',
    cell: info => {
      const domain = info.getValue();
      const addProtocolIfMissing = (url: string) => {
        if (url.startsWith('http://') || url.startsWith('https://')) {
          return url;
        }

        return `http://${url}`;
      };
      const domainWithProtocol = addProtocolIfMissing(domain);

      if (checkIsUrl(domainWithProtocol)) {
        return (
          <div className="w-40 max-w-40 min-w-0 px-2">
            <BallerineLink
              href={domainWithProtocol}
              className="block truncate justify-start"
              title={domain}
            >
              {domain}
            </BallerineLink>
          </div>
        );
      }

      return (
        <div className="w-40 max-w-40 min-w-0 px-2">
          <TextWithNAFallback className="block truncate" title={domain}>
            {domain}
          </TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('relatedNodeType', {
    header: 'Related Node Type',
    cell: info => {
      const relatedNodeType = info.getValue();

      return (
        <div className="w-32 max-w-32 min-w-0">
          <TextWithNAFallback className="truncate">{relatedNodeType}</TextWithNAFallback>
        </div>
      );
    },
  }),
  columnHelper.accessor('relatedNode', {
    header: 'Related Node',
    cell: info => {
      const relatedNode = info.getValue();

      return (
        <div className="min-w-0 max-w-96 px-2">
          <TextWithNAFallback
            className="block break-words whitespace-pre-wrap line-clamp-3"
            title={relatedNode}
          >
            {relatedNode}
          </TextWithNAFallback>
        </div>
      );
    },
  }),
] as const;
